import React, {PropTypes,Component}  from 'react';
import "./style.less"
import tools from "../../utils/tools"

class ColumnsContent extends Component{

    constructor(props,context){
        super(props,context);
    }

    renderColumn(simpleColumn,index){
      var {overallConfig} =this.props;
      var style={};
      var simpleColumnTitleStyle={};
      let value = simpleColumn.value;

      if(simpleColumn.thick){//加粗
        style.fontWeight="bold";
        simpleColumnTitleStyle.fontWeight="bold";
      }
      if(simpleColumn.format){//fomat
        value=tools.formatDisplay(value,simpleColumn.format)
      }
      if (overallConfig&&value&&simpleColumn.type==1) {
        if(overallConfig.isRedWord&&value<0){//变红
          style.color="#bb1a12";
        }
        if(overallConfig.IsShowThousandsSeparator&&simpleColumn.format!='P'&&simpleColumn.type=='1'){
          value=tools.thousandthNum(value)
        }
      }
      // if(simpleColumn.){

      // }
      return (
        <span className="detailColums" style={{'-webkit-box-orient':'vertical'}} key={'detailColums'+index}>
        <span style={simpleColumnTitleStyle}>{simpleColumn.title}</span>
        <span style={style}>{value}</span>
        </span>
      )
    }

    renderRows(row,index){
      var _this=this;
      return (
        <div style={{overflow:"hidden"}} key={'detailContent'+index}>
          {
            row.map(function(simpleColumn,index){
              return _this.renderColumn(simpleColumn,index)
            })
          }
        </div>
      )
    }

    render(){
      var _this=this;
      var {simpleContent,overallConfig} =this.props;
      var rowLength=Math.floor(simpleContent.length/2);
      var rows=new Array(rowLength);
      simpleContent.forEach(function(simpleColumn,index){
       rows[Math.floor(index/2)]?rows[Math.floor(index/2)].push(simpleColumn):rows[Math.floor(index/2)]=[simpleColumn]
      })
      return (
        <div className="detailContent">
          {
            rows.map(function(row,index){
              return _this.renderRows(row,index);
            })
          }
        </div>
      )
    }

}
export default ColumnsContent
